export default "__VITE_PUBLIC_ASSET__43a34778__"